export default __webpack_public_path__ + "static/media/filter-img.34a8c56a.svg";